import TextArea from 'modules/common/components/TextArea';
import { ComponentProps, FC } from 'react';
import { useController, UseControllerProps } from 'react-hook-form';

type PropTypes = {
  controlled: UseControllerProps<any>;
} & ComponentProps<typeof TextArea>;

const ControlledTextArea: FC<PropTypes> = ({
  controlled,
  maxLength = 225,
  autoSize = { minRows: 2, maxRows: 10 },
  style,
  ...restProps
}) => {
  const controller = useController(controlled);
  return (
    <TextArea
      {...controller.field}
      maxLength={maxLength}
      autoSize={autoSize}
      style={{ resize: 'none', ...style }}
      {...restProps}
    />
  );
};

export default ControlledTextArea;
